import Picture from './picture.entity';
import Change from '../changes/change.entity';
import CmChangePicture from '../cm-change-pictures/cm-change-picture.entity';
import CmEpisodicItemPicture from '../cm-episodic-item-pictures/cm-episodic-item-picture.entity';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';
import EpisodicCharacterPicture from '../episodic-character-pictures/episodic-character-picture.entity';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import HaChange from '../ha-changes/ha-change.entity';
import HaLookPicture from '../ha-look-pictures/ha-look-picture.entity';
import MuChange from '../mu-changes/mu-change.entity';
import MuLookPicture from '../mu-look-pictures/mu-look-picture.entity';
import PictureScene from '../picture-scenes/picture-scene.entity';
import PrEpisodicPropPicture from '../pr-episodic-prop-pictures/pr-episodic-prop-picture.entity';
import PrWrapBox from '../pr-wrap-boxes/pr-wrap-box.entity';
import Scene from '../scenes/scene.entity';
import SetPicture from '../set-pictures/set-picture.entity';
import SetPiecePicture from '../set-piece-pictures/set-piece-picture.entity';
import SetPiece from '../set-pieces/set-piece.entity';
import SetWrapBox from '../set-wrap-boxes/set-wrap-box.entity';
import Set from '../sets/set.entity';
import {
	SosDeleteResponse,
	SosGetResponse,
	SosUpdateResponse,
} from '../sos-response';
import Episodic from '../episodics/episodic.entity';

export interface PictureGetResponse extends SosGetResponse {
	listed: {
		Picture: Picture[];
	};
}

export interface PictureUpdateResponse extends SosUpdateResponse {
	updated: {
		Picture: Picture[];
	};
}

export interface PictureDeleteResponse extends SosDeleteResponse {
	destroyed: {
		CmChangePicture: CmChangePicture[];
		CmEpisodicItemPicture: CmEpisodicItemPicture[];
		EpisodicCharacterPicture: EpisodicCharacterPicture[];
		HaLookPicture: HaLookPicture[];
		MuLookPicture: MuLookPicture[];
		Picture: Picture[];
		PictureScene: PictureScene[];
		PrEpisodicPropPicture: PrEpisodicPropPicture[];
		SetPicture: SetPicture[];
		SetPiecePicture: SetPiecePicture[];
	};
}

export interface PictureSetMainPhotoResponse extends SosUpdateResponse {
	updated: {
		CmChangePicture?: CmChangePicture[];
		CmEpisodicItemPicture?: CmEpisodicItemPicture[];
		EpisodicCharacterPicture?: EpisodicCharacterPicture[];
		HaLookPicture?: HaLookPicture[];
		MuLookPicture?: MuLookPicture[];
		PictureScene?: PictureScene[];
		PrEpisodicPropPicture?: PrEpisodicPropPicture[];
		SetPicture?: SetPicture[];
		SetPiecePicture?: SetPiecePicture[];
	};
}

export interface TagEntities {
	CmWrapBox?: CmWrapBox[];
	Change?: Change[];
	/** Used for Episodic Logo Pictures */
	Episodic?: Episodic[];
	EpisodicActor?: EpisodicActor[];
	EpisodicCharacter?: EpisodicCharacter[];
	EpisodicItem?: EpisodicItem[];
	EpisodicProp?: EpisodicProp[];
	HaChange?: HaChange[];
	MuChange?: MuChange[];
	PrWrapBox?: PrWrapBox[];
	Scene?: Scene[];
	Set?: Set[];
	SetWrapBox?: SetWrapBox[];
	SetPiece?: SetPiece[];
}

export interface PartialTagEntities {
	CmWrapBox?: Partial<CmWrapBox>[];
	Change?: Partial<Change>[];
	/** Used for Episodic Logo Pictures */
	Episodic?: Partial<Episodic>[];
	EpisodicActor?: Partial<EpisodicActor>[];
	EpisodicCharacter?: Partial<EpisodicCharacter>[];
	EpisodicItem?: Partial<EpisodicItem>[];
	EpisodicProp?: Partial<EpisodicProp>[];
	HaChange?: Partial<HaChange>[];
	MuChange?: Partial<MuChange>[];
	PrWrapBox?: Partial<PrWrapBox>[];
	Scene?: Partial<Scene>[];
	Set?: Partial<Set>[];
	SetWrapBox?: Partial<SetWrapBox>[];
	SetPiece?: Partial<SetPiece>[];
}

export interface PhotoFile {
	imageName: string;
	imageBody: string;
	imageExtension: string;
}

export interface PhotoUploadData {
	file: PhotoFile;
	description?: string;
	isEstablishing?: boolean;
	isResearch?: boolean;
	main?: boolean;
	rotation?: number;
}

export interface PictureUpload extends PhotoUploadData, TagEntities {}

export interface PictureRelationEntities {
	CmChangePicture?: CmChangePicture;
	CmEpisodicItemPicture?: CmEpisodicItemPicture;
	EpisodicCharacterPicture?: EpisodicCharacterPicture;
	HaLookPicture?: HaLookPicture;
	MuLookPicture?: MuLookPicture;
	PictureScene?: PictureScene;
	PrEpisodicPropPicture?: PrEpisodicPropPicture;
	SetPicture?: SetPicture;
	SetPiecePicture?: SetPiecePicture;
}
